import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ClampLines from 'react-clamp-lines';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getLegacySession } from '../../../bridge';
import { formatDate } from '../../../helpers/itpmetricsUtils';
import { getCookieValue, getLanguage } from '../../../helpers/utils';

import './DashboardCard.scss';

function LegacyReportCard({ item }) {
  const navigate = useNavigate();
  const onClick = async () => {
    if (item.templateName === 'Peer Feedback - Self Rated, Peer Rated, and Group Median') {
      const { response: { sessionId, url } } = await getLegacySession();
      const language = getLanguage();
      const queryParams = `ltiSessionId=${sessionId}&language=${language}&guid=${item.respondentId}`;
      const newUrl = `${url}/report?${queryParams}`;
      if (isMobile) {
        window.location.href = newUrl;
      } else {
        window.open(newUrl);
      }
    } else {
      navigate(`/legacy/report/${item.respondentId}`);
    }
  };
  const row = getCookieValue('display-rows');

  return row ? (
    <Card
      onClick={onClick}
      className="dashboard-card-row p-2"
    >
      <Row>
        <Col sm={6} md={6} lg={6}>
          <ClampLines
            text={item.name}
            lines={1}
            buttons={false}
            className="dashboard-card-title"
          />
        </Col>
        <Col>
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8em',
          }}
          >
            {item.templateName}
          </div>
        </Col>
        <Col>
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.7em',
          }}
          >
            {formatDate(item.dateCreated)}
          </div>
        </Col>
      </Row>
    </Card>
  ) : (
    <Card
      onClick={onClick}
      className="mx-2 my-3 dashboard-card"
    >
      <Card.Body>
        <>
          <ClampLines
            text={item.name}
            lines={2}
            buttons={false}
            className="dashboard-card-title"
          />
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8em',
          }}
          >
            {item.templateName}
          </div>
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.7em',
          }}
          >
            {formatDate(item.dateCreated)}
          </div>
        </>
      </Card.Body>
    </Card>
  );
}

LegacyReportCard.propTypes = {
  item: PropTypes.object,
};

export default LegacyReportCard;
